"use client";
import "../contexts/language/LanguageContext.js";
import "react/jsx-runtime";
import { t as translations } from "../translations-DcLD4XBj.js";
import { useLanguage } from "./useLanguage.js";
const useLocaleText = () => {
  const { language } = useLanguage();
  return translations[language];
};
export {
  useLocaleText
};
